import DiscountStatusDTO from './DiscountStatusDTO';

export default class DiscountLevelDTO {
    id: number;

    percent: number;

    name: string | null;

    description: string | null;

    status: DiscountStatusDTO;

    constructor({
        Id = 0,
        Percent = 0,
        Name = null,
        Description = null,
        Status = {}
    }: {
        Id?: number;
        Percent?: number;
        Name?: string | null;
        Description?: string | null;
        Status?: any;
    } = {}) {
        this.id = Id;
        this.percent = Percent;
        this.name = Name;
        this.description = Description;
        this.status = Status ? new DiscountStatusDTO(Status) : null;
    }
}
